import { Theme } from '@mui/material/styles'

const useStyles = {
  section: (theme: Theme) => ({
    border: '1px solid rgba(0, 0, 0, 0.05)',
    borderRadius: '12px',
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(3),
    width: '100%',
  }),
  sectionDivider: (theme: Theme) => ({
    margin: theme.spacing(0, -2),
  }),
  titleComponentContainer: (theme: Theme) => ({
    borderRadius: '12px 12px 0 0',
    padding: theme.spacing(1.5, 2),
    margin: theme.spacing(-1.5, -2, 0),
    backgroundColor: theme.palette.action.hover,
  }),
}

export default useStyles
